import userImg from '../../assets/img/blog/author2.jpg';
import chart from '../../assets/img/chart.png';

const analyticsData = {
    heading: 'Providing solutions of every kind.',
    subHeading:
        'Testfabrics is a world-leading producer and distributor of textile testing media. They provide a wide range of services to their clients, including quality assurance testing, colorfastness testing, and physical testing. Testfabrics is committed to providing their clients with the highest quality products and services.',
    desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    userName: 'Miranda H.',
    userPosition: 'Founder',
    userImg,
    userPhone: '963. 369. 265. 56',
    chart,
};

export default analyticsData;
